import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=073d64ab&scoped=true"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"
import style0 from "./Index.vue?vue&type=style&index=0&id=073d64ab&prod&scoped=true&lang=css"
import style1 from "./Index.vue?vue&type=style&index=1&id=073d64ab&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "073d64ab",
  null
  
)

export default component.exports